<div class="bg-gray-100 p-4 mt-4 mb-4 ">
    <h1 class="font-extrabold text-2xl p-6">New releases</h1>
    <div class="flex flex-row overflow-scroll bg-scroll no-scrollbar">
      <ul *ngFor="let item of newReleases">
        <app-card [detail]="item"></app-card>
      </ul>
    </div>
</div>